export default {
  createContent: {
    pageTitle: "Đăng ký tác phẩm mới",
    pageDescription:
      "Gửi đăng ký tác phẩm sáng tạo của bạn để bảo vệ quyền sở hữu",
    pageKeywords:
      "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",

    protectedWithWatermark: "• Có watermark bảo vệ",
    withWatermark: "Có watermark",

    steps: {
      upload: "Tải lên",
      info: "Thông tin",
      distribution: "Phân phối",
      protection: "Bảo vệ",
      confirm: "Xác nhận",
    },
    fields: {
      contentKind: "Loại tác phẩm",
      uploadTitle: "Tải lên tác phẩm",
      selectedFile: "Đã chọn {{count}} tệp",
      title: "Tiêu đề tác phẩm",
      titlePlaceholder: "Nhập Tiêu đề tác phẩm",
      description: "Mô tả",
      descriptionPlaceholder: "Mô tả chi tiết về tác phẩm",
      descriptionNote: "{{length}}/1000 ký tự",
      isPublic: "Hiển thị trong danh mục công khai",
      isPublicHelp:
        "Nếu được chọn, tác phẩm của bạn sẽ hiển thị trong danh mục công khai và có thể được tìm kiếm bởi người mua tiềm năng",
      collaboratorsEmpty: "Không có người đóng góp nào được thêm vào.",
      collaboratorsHelp:
        "Bạn sẽ được liệt kê là người sáng tạo duy nhất với 100% quyền sở hữu.",
      collaboratorName: "Tên",
      collaboratorEmail: "Email",
      collaboratorShare: "Tỷ lệ phân phối (%)",
      totalDistribution: "Tổng tỷ lệ phân phối:",
      totalDistributionError: "Tổng tỷ lệ phân phối phải bằng 100%.",
      minioTotalSize: "Tổng dung lượng",
      minioPath: "Đường dẫn MinIO",
      minioSize: "Kích thước",
      minioProtected: "Bảo vệ",


      protection: {
        title: "Biện pháp bảo vệ",
        description:
          "Chọn biện pháp bảo vệ cho tác phẩm của bạn. \nCác biện pháp bảo vệ giúp ngăn chặn sử dụng trái phép và tăng cường khả năng bảo vệ quyền sở hữu.",
        watermark: "Watermark tự động",
        watermarkDesc:
          "Thêm watermark kỹ thuật số vào tác phẩm của bạn để ngăn chặn sao chép trái phép.",
        aiMonitoring: "AI Monitoring",
        aiMonitoringDesc:
          "Sử dụng AI để quét và phát hiện vi phạm bản quyền trên các nền tảng trực tuyến.",
        blockchain: "Chứng nhận Blockchain",
        blockchainDesc:
          "Đăng ký tác phẩm của bạn trên blockchain để xác minh quyền sở hữu và tính xác thực.",
        score: "Điểm bảo vệ ước tính",
        scoreHelp:
          "Điểm bảo vệ cho biết mức độ bảo vệ tác phẩm của bạn. Điểm cao hơn có nghĩa là tác phẩm được bảo vệ tốt hơn.",
        protectionScore: "Điểm số bảo vệ",
      },
      confirmation: {
        title: "Tất cả thông tin đã sẵn sàng!",
        description:
          'Vui lòng xem lại thông tin tác phẩm của bạn và nhấn "Đăng ký" để hoàn tất.',
        workInfo: "Thông tin tác phẩm",
        collaboratorInfo: "Người đóng góp",
        protectionInfo: "Biện pháp bảo vệ",
        minioInfo: "Trạng thái lưu trữ MinIO",
        noteValidateTerms: "Vui lòng đồng ý với cả hai điều khoản trên để tiếp tục xác thực thông tin.",
        terms: "Tôi đồng ý với Điều khoản và Điều kiện sử dụng",
        ownership:
          "Tôi xác nhận rằng tôi có quyền đăng ký bản quyền cho tác phẩm này",
        on: "Bật",
        off: "Tắt",
      },
    },
    success: {
      title: "Đăng ký thành công!",
      description: "Tác phẩm của bạn đã được đăng ký thành công và đang chờ xét duyệt.",
      viewAll: "Xem danh sách tác phẩm",
      registerAnother: "Đăng ký tác phẩm khác"
    },

    message: {
      validationTitle: "Vui lòng kiểm tra và sửa các lỗi sau",
      requiredTitle: "Thông tin bắt buộc",
      invalidTitle: "Thông tin không hợp lệ",
      incompleteErrorsTitle: "Thông tin chưa hoàn thiện",
      errorContentKindRequired: "Vui lòng chọn loại nội dung.",
      errorFileRequired: "Vui lòng tải lên ít nhất một tập tin.",
      errorTitleRequired: "Tiêu đề không được để trống",
      errorTitleInvalid: "Tiêu đề không hợp lệ hoặc phải nhiều hơn 5 ký tự.",
      errorCategoryRequired: "Vui lòng chọn danh mục.",
      errorDescriptionInvalid: "Mô tả không được vượt quá 1000 ký tự.",
      errorTermsRequired: "Vui lòng đồng ý với điều khoản để có thể tiếp tục.",
      errorTermsAgreed: "Vui lòng đồng ý với điều khoản sử dụng",
      errorOwnershipAgreed: "Vui lòng xác nhận quyền sở hữu tác phẩm",
      errorRegisterWorkFailed: "Đăng ký tác phẩm thất bại"

    },
  },
  contentManagement: {
    pageTitle: "Quản lý Catalog",
    pageDescription: "Hiển thị {{value}}/{{total}} tác phẩm",
    pageKeywords:
      "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",
    view: {
      issuedCertificates: "Chứng nhận đã cấp ({{count}})",
      applicationForms: "Đơn đăng ký ({{count}})",
      issuingAgency: "Cơ quan cấp",
      issueDate: "Ngày cấp",
      expiryDate: "Hết hạn",
      verificationCode: "Mã xác thực",
    }
  },
  works: {
    pageTitle: "Danh sách tác phẩm cộng đồng",
    pageDescription: "Khám phá {{total}} tác phẩm được bảo vệ bản quyền từ cộng đồng",
    pageKeywords:
      "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",
    statistics: {
      totalWorks: 'Tổng tác phẩm',
      totalViews: 'Tổng lượt xem',
      totalLikes: 'Tổng lượt thích',
      avgProtection: 'Bảo vệ trung bình'
    }
  },
  updateMetadata: {
    pageTitle: "Cập nhật metadata",
    pageDescription: "Chỉnh sửa thông tin chi tiết và files của tác phẩm",
    pageKeywords: "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",

    basicInfo: "Thông tin cơ bản",
    workInfo: "Thông tin tác phẩm",
    workTitle: "Tiêu đề tác phẩm",
    mainTitle: "Tiêu đề chính của tác phẩm",
    description: "Mô tả",
    workDescription: "Mô tả chi tiết về tác phẩm",
    addKeywords: "Thêm từ khóa để giúp người khác tìm thấy tác phẩm",
    manageFiles: "Quản lý tệp",
    currentFiles: "Tệp hiện tại",
    newFile: "Tệp mới",
    newFilesWillBeAdded: "Tệp mới sẽ được thêm",
    changeSummary: "Tóm tắt thay đổi",
    addNewFilesCount: "Thêm {{count}} tệp mới",
    deleteFilesCount: "Xóa {{count}} tệp hiện tại",
    changeDescription: "Mô tả thay đổi",
    changeDescriptionPlaceholder: "Mô tả những thay đổi bạn đã thực hiện...",
    changeDescriptionRequired: "Vui lòng mô tả những thay đổi bạn đã thực hiện",
    currentVersion: "Phiên bản hiện tại: v{{ver}}"
  },
  publishing: {
    pageTitle: "Đăng bán nội dung",
    pageDescription: "Quản lý và đăng bán nội dung đã được chứng nhận lên marketplace",
    pageKeywords: "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",

    certifiedContent: "Nội dung đã chứng nhận",
    publishedOnMarketplace: "Đã đăng Marketplace",
    notPublished: "Chưa đăng bán",
    publishingRate: "Tỷ lệ đăng bán",
    searchTermPlaceholder: "Tìm kiếm theo tên nội dung...",
    dataEmpty: "Hãy đăng ký nội dung để bắt đầu bán trên marketplace",
    dataNotFound: "Thử điều chỉnh bộ lọc hoặc từ khóa tìm kiếm",

    modal: {
      title: "Đăng tác phẩm lên Marketplace",
      shortDescription: "Mô tả ngắn cho Marketplace",
      featured: "Đề xuất làm tác phẩm nổi bật",
      licenseOptions: "Tùy chọn License và Giá",
      alertLicenseOptions: "Không có license template nào trong hệ thống. Vui lòng liên hệ admin.",
      licenses: {
        standardLicense: {
          title: "Giấy phép cơ bản",
          description: "Giấy phép cơ bản cho sử dụng phi thương mại",
        },
        note: "Ít nhất một loại license phải được kích hoạt",
      }
    }
  },
  contentDetail: {
    pageTitle: "Chi tiết Tác phẩm",
    pageKeywords: "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",    
  }
};
